import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const snipeIt = defineConnector({
  identifier: "snipeIt",
  name: "Snipe-IT",
  tagLine: "IT asset management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ instanceUrl }) => urlToPattern(instanceUrl),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create a Snipe-IT API token",
      items: [
        {
          kind: "markdown",
          content:
            'In Snipe-IT, open the user menu, choose "Manage API keys," and create a new token. Snipe-IT expects the token in the `Authorization: Bearer` header.',
        },
      ],
    },
    {
      title: "Enter your Snipe-IT details",
      items: [
        {
          kind: "baseUrl",
          label: "Snipe-IT base URL",
          required: true,
          placeholder: "https://assets.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://assets.example.com"}/api/v1/hardware`,
  },
});
